export const TRANSLATION_KEYS = {
  widgetTitle: 'jbp-thing-to-improve',

  attachments: 'jbp-key-initiatives-attachments',

  keyInitiativesFormat: 'jbp-key-initiatives-format',

  keyInitiativeEditor: {
    isNotApplicable: 'jbp-key-initiative-editor-not-aplicable',
    isApplicable: 'jbp-key-initiative-editor-aplicable',
    name: 'jbp-key-initiatives-name',
    keyInitiativeTitle: 'jbp-key-initiatives-create-key-initiative-title',
    parentKeyInitiativeTitle: 'jbp-key-initiatives-edit-parent-key-initiative-title',
    focusStatus: 'jbp-key-initiatives-focus-status',
    productLinesSelect: 'jbp-key-initiatives-products',
    categoryDropdown: 'jbp-key-initiatives-category',
    widgetViewLabel: 'jbp-key-initiatives-widget-view-label',

    businessUnitAndFocusFieldGroup: {
      groupHint: 'jbp-key-initiatives-business-unit-and-focus-hint-label',
      businessUnit: 'jbp-key-initiatives-business-unit',
      focusArea: 'jbp-key-initiatives-focus-area',
      description: 'jbp-key-initiatives-description',
      currentProgress: 'jbp-key-initiatives-current-progress',
      currentProgressPlaceholder: 'jbp-key-initiatives-current-progress-placeholder',
      followUp: 'jbp-key-initiatives-follow-up',
      followUpPlaceholder: 'jbp-key-initiatives-follow-up-placeholder',

      groupLabel: 'jbp-key-initiatives-business-unit-and-focus-label',
      groupDesc: 'jbp-key-initiatives-business-unit-and-focus-description',
    },
    keyInitiativeAndPeriodFieldGroup: {
      groupHint: 'jbp-key-initiatives-objective-and-period-hint-label',

      strategicInitiativeLabel: 'jbp-key-initiatives-strategic-initiative-label',
      periodLabel: 'jbp-key-initiatives-period-label',
      initiativeNameLabel: 'jbp-key-initiatives-initiative-name-label',
      descriptionLabel: 'jbp-key-initiatives-description-label',
      partnerContactLabel: 'jbp-key-initiatives-partner-contact-label',
      secondaryIniativeLabel: 'jbp-key-initiatives-secondary-iniative-label',

      strategicInitiativeDesc: 'jbp-key-initiatives-strategic-initiative-description',
      periodDesc: 'jbp-key-initiatives-period-description',
      initiativeNameDesc: 'jbp-key-initiatives-initiative-name-description',
      descriptionDesc: 'jbp-key-initiatives-description-description',
      partnerContactDesc: 'jbp-key-initiatives-partner-contact-description',
      secondaryIniativeDesc: 'jbp-key-initiatives-secondary-iniative-description',

      development: 'jbp-key-initiatives-development',
      keyObjectiveTags: 'jbp-key-initiatives-key-objective-tags',
      activityType: 'jbp-key-initiatives-activity-type',
      period: 'jbp-key-initiatives-period',
      owner: 'jbp-key-initiatives-owner',
    },
    checkboxesFieldGroup: {
      groupHint: 'jbp-key-initiatives-checkboxes-hint-label',
      shouldAddToBridgesHint: 'jbp-key-initiatives-should-add-to-bridges-hint-label',
      shouldAddToBridges: 'jbp-key-initiatives-should-add-to-bridges',
      dataInsightRelatedHint: 'jbp-key-initiatives-data-insight-related-hint-label',
      dataInsightRelated: 'jbp-key-initiatives-data-insight-related',

      shouldAddToBridgesLabel: 'jbp-key-initiatives-should-add-to-bridges-label',
      shouldAddToBridgesDesc: 'jbp-key-initiatives-should-add-to-bridges-description',

      dataInsightRelatedLabel: 'jbp-key-initiatives-data-insight-related-label',
      dataInsightRelatedDesc: 'jbp-key-initiatives-data-insight-related-description',
    },
    goalFieldGroup: {
      groupHint: 'jbp-key-initiatives-goal-hint-label',
      warning: 'jbp-key-initiatives-goal-warning-label',
      emptyPlan: 'jbp-key-initiatives-goal-empty-plan-label',
      error: 'jbp-key-initiatives-goal-error-label',
      justification: 'jbp-key-initiatives-goal-justification-label',

      groupLabel: 'jbp-key-initiatives-goal-group-label',
      groupDesc: 'jbp-key-initiatives-goal-group-description',

      goalLabel: 'jbp-key-initiatives-goal-label',
      goalDesc: 'jbp-key-initiatives-goal-description',
      incrementalLabel: 'jbp-key-initiatives-incremental-label',
      incrementalDesc: 'jbp-key-initiatives-incremental-description',
    },
    investmentFieldGroup: {
      groupHint: 'jbp-key-initiatives-investment-hint-label',
      investmentSum: 'jbp-key-initiatives-investment-sum',
      investmentSource: 'jbp-key-initiatives-investment-source',
    },
    mdfFieldGroup: {
      title: 'jbp-key-initiatives-editor-mdf-title',
      empty: 'jbp-key-initiatives-editor-mdf-empty',
      unsaved: 'jbp-key-initiatives-editor-mdf-unsaved',
      loadError: 'jbp-key-initiatives-editor-mdf-load-error',
      retry: 'jbp-key-initiatives-editor-mdf-retry',
      planned: 'jbp-key-initiatives-editor-mdf-planned',
      paid: 'jbp-key-initiatives-editor-mdf-paid',
      sales: 'jbp-key-initiatives-editor-mdf-sales',
      contra: 'jbp-key-initiatives-editor-mdf-contra',
    },
    capabilitiesPillarInitiativeFieldGroup: {
      groupHint: 'jbp-key-initiatives-capabilities-pillar-hint-label',
      goalDescription: 'jbp-key-initiatives-goal-description',
      proofOfExecution: 'jbp-key-initiatives-proof-of-execution',
      isAchieved: 'jbp-key-initiatives-is-achieved-label',
    },
    practiceDevelopment: {
      description: 'jbp-key-initiatives-practice-development-description',
    },
    progressView: {
      groupHint: 'jbp-key-initiatives-progress-view-hint-label',

      statusLabel: 'jbp-key-initiatives-progress-view-status-label',
      statusDesc: 'jbp-key-initiatives-progress-view-status-description',

      currentProgressLabel: 'jbp-key-initiatives-progress-view-current-progress-label',
      currentProgressDesc: 'jbp-key-initiatives-progress-view-current-progress-description',

      followUpLabel: 'jbp-key-initiatives-progress-view-follow-up-label',
      followUpDesc: 'jbp-key-initiatives-progress-view-follow-up-description',
    },
  },

  gpKeyInitiativeEditor: {
    geo: 'jbp-key-initiatives--gp-editor--geo',
    affectToIncludingPartners: 'jbp-key-initiatives--gp-editor--affect-to-including-partners',
  },
  addNewButton: 'jbp-key-initiatives-add-new',
  initiativesWarning: {
    initiativesWarningCompletedMessage: 'jbp-key-initiatives-warning-completed-message',
  },
  initiativesMessage: {
    initiativesCompletedMessage: 'jbp-key-initiatives-completed-message',
  },
  switchers: {
    growthPlaySwithcer: 'jbp-key-initiatives-growth-play-switcher',
    growthPlayTooltip: 'jbp-key-initiatives-growth-play-tooltip',
    amplifyImpactSwithcer: 'key-initiatives-ai-switcher',
    amplifyImpactTooltip: 'key-initiatives-ai-tooltip',
  },
  filters: {
    focusArea: 'jbp-key-initiatives-focus-area-filter-label',
    keyObjective: 'jbp-key-initiatives-key-objective-filter-label',
    showAssignedInitiatives: 'jbp-key-initiatives-lp-show-assigned-initiatives',
    showAffectedInitiatives: 'jbp-key-initiatives-gp-show-assigned-initiatives',
  },

  tableColumns: {
    businessUnit: 'jbp-key-initiatives-business-unit',
    focusArea: 'jbp-key-initiatives-focus-area',
    name: 'jbp-key-initiatives-name',
    description: 'jbp-key-initiatives-description',
    period: 'jbp-key-initiatives-period',
    owner: 'jbp-key-initiatives-owner',
    bridges: 'jbp-key-initiatives-bridges-column-title',
    keyObjectiveTags: 'jbp-key-initiatives-key-objective-tags-column-title',
    goal: 'jbp-key-initiatives-goal',
    isAchieved: 'jbp-key-initiatives-is-achieved',
    investmentNeeds: 'jbp-key-initiatives-investment-needs',
    investmentSum: 'jbp-key-initiatives-investment-sum',
    investmentSource: 'jbp-key-initiatives-investment-source',
    focusStatus: 'jbp-key-initiatives-focus-status',
    category: 'jbp-actionplans-strategies-goals-category',
    currentProgress: 'jbp-key-initiatives--table-column--current-progress',
    followUp: 'jbp-key-initiatives--table-column--follow-up',
  },

  gpTableColumns: {
    goal: 'jbp-key-initiatives--gp-table-goal',
    rollupGoal: 'jbp-key-initiatives--gp-table-rollup-goal',
    partnersImpact: 'jbp-key-initiatives--gp-table-partners-impact',
    rollupPartnersImpactApplicableCount:
      'jbp-key-initiatives--gp-table-partners-impact-applicable-count',
    rollupPartnersImpactNotApplicableCount:
      'jbp-key-initiatives--gp-table-partners-impact-not-applicable-count',
    rollupPartnersCount: 'jbp-key-initiatives--gp-table-rollup-partners-count',
    rollupPartnersPendingCount: 'jbp-key-initiatives--gp-table-rollup-partners-pending-count',
    gpHpInvestmentSum: 'jbp-key-initiatives--gp-table-hp-investment-sum',
  },

  copyFromPreviousYear: {
    buttonTitle: 'jbp-key-initiatives-copy-from-prev-year',
    confirm: 'jbp-key-initiatives-copy-from-prev-year-confirm',
    submit: 'jbp-key-initiatives-copy-from-prev-year-submit',
  },

  checkboxRollup: 'jbp-key-initiatives-check-box-rollup',

  rollUpTableColumns: {
    geo: 'jbp-key-initiatives--table-columns--geo',
    initiatives: 'jbp-key-initiatives--table-column--initiatives',
    keyObjectives: 'jbp-key-initiatives--table-column--key-objectives',
    finGoal: 'jbp-key-initiatives--table-column--fin-goal',
    funds: 'jbp-key-initiatives--table-column--funds',
    bridges: 'jbp-key-initiatives--table-column--bridges',
    status: 'jbp-key-initiatives--table-column--status',
    focusArea: 'jbp-key-initiatives--table-column--focus-area',
    bu: 'jbp-key-initiatives--table-column--bu',
    owner: 'jbp-key-initiatives--table-column--owner',
    period: 'jbp-key-initiatives--table-column--period',
    description: 'jbp-key-initiatives--table-column--description',
  },

  rollUpFilters: {
    focusArea: 'jbp-key-initiatives--roll-up-filters--focus-area',
    keyObjectives: 'jbp-key-initiatives--roll-up-filters--key-objectives',
    businessUnits: 'jbp-key-initiatives--roll-up-filters--business-units',
    apply: 'jbp-key-initiatives--roll-up-filters--apply',
    cancel: 'jbp-key-initiatives--roll-up-filters--cancel',
  },

  affectedLPModal: {
    headerDelete: 'jbp-key-initiatives--affected-lp-modal-header-delete',
    headerUpdate: 'jbp-key-initiatives--affected-lp-modal-header',
    textDelete: 'jbp-key-initiatives--affected-lp-modal-text-delete',
    textUpdate: 'jbp-key-initiatives--affected-lp-modal-text',
    agree: 'jbp-key-initiatives--affected-lp-modal-agree',
    cancel: 'jbp-key-initiatives--affected-lp-modal-cancel',
  },
}
